import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  role: "alert",
  class: "alert alert-warning"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "in-alert" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  class: "form-horizontal form-sent-geo tacho-files-form",
  role: "form"
}
const _hoisted_9 = { class: "form-body" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12 d-flex flex-row gap-2" }
const _hoisted_13 = { class: "errors" }
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = {
  key: 0,
  class: "checkboxes"
}
const _hoisted_16 = { for: "events" }
const _hoisted_17 = { for: "technicalData" }
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "action-buttons" }
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { style: {"color":"red !important"} }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_35 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { style: {"color":"red !important"} }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_44 = {
  key: 1,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Tabs, null, {
      "tab-selector": _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([{ active: _ctx.tabContent === _ctx.TAB_AVAILABLE_FILES }, "tab-link"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab(_ctx.TAB_AVAILABLE_FILES)))
        }, _toDisplayString(_ctx.$t('components.tachographFiles.tabs.availableFiles')), 3),
        _createElementVNode("button", {
          class: _normalizeClass([{ active: _ctx.tabContent === _ctx.TAB_TASKS }, "tab-link"]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_TASKS)))
        }, _toDisplayString(_ctx.$t('components.tachographFiles.tabs.tasks')), 3),
        _createElementVNode("button", {
          class: _normalizeClass([{ active: _ctx.tabContent === _ctx.TAB_REMINDERS }, "tab-link"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab(_ctx.TAB_REMINDERS)))
        }, _toDisplayString(_ctx.$t('components.tachographFiles.tabs.reminders')), 3)
      ]),
      "tab-content": _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.tachographFilesGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.availableFilesStore,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            "download-cell-template": _withCtx(({ data }) => [
              _createElementVNode("a", {
                href: '//' + _ctx.getInstance() + '/downloads/tacho_files/' + data.data.filename
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-download" })
              ], 8, _hoisted_1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: true }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 20
              }),
              _createVNode(_component_DxPager, {
                "show-info": true,
                "show-navigation-buttons": true,
                visible: true,
                "info-text": _ctx.$t('components.devexpress.pagerPage')
                + '{0}' + _ctx.$t('components.devexpress.pagerOf')
                + '{1}'
              }, null, 8, ["info-text"]),
              _createVNode(_component_DxSearchPanel, {
                visible: true,
                width: 240,
                placeholder: _ctx.$t('components.tachographFiles.dataGrids.search')
              }, null, 8, ["placeholder"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.source'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "source"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.fileType'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "type"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.imei'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "imei"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.date'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "updated_at"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.fileSize'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "file_size"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachographFiles.dataGrids.download'),
                "cell-template": "download-cell-template",
                "allow-search": false
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"])
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_AVAILABLE_FILES]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", {
              innerHTML: _ctx.$t('components.tachographFiles.downloadAlert.p1')
            }, null, 8, _hoisted_3),
            _createElementVNode("p", {
              class: "in-alert",
              innerHTML: _ctx.$t('components.tachographFiles.downloadAlert.p2')
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              class: "in-alert",
              innerHTML: _ctx.$t('components.tachographFiles.downloadAlert.p3')
            }, null, 8, _hoisted_5),
            _createElementVNode("p", _hoisted_6, [
              _createElementVNode("a", {
                href: _ctx.url + '/downloads/tachoapp-latest.jar',
                class: "btn btn-info btn-sm",
                target: "_blank"
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-download" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.downloadAlert.button')), 1)
              ], 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_vue_select, {
                      modelValue: _ctx.v.source.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v.source.$model) = $event)),
                      options: _ctx.tachoSources,
                      class: _normalizeClass(["flex-grow", { 'custom-error': _ctx.v.source.$error, 'is-invalid': _ctx.v.source.$error }]),
                      icon: "bi bi-truck",
                      style: {"flex-basis":"50%"},
                      label: "label",
                      onUpdateSelect: _ctx.emit
                    }, null, 8, ["modelValue", "options", "class", "onUpdateSelect"]),
                    (_ctx.source !== null && _ctx.source.type === 'transmitter')
                      ? (_openBlock(), _createBlock(_component_date_picker, {
                          key: 0,
                          modelValue: _ctx.v.dateFrom.$model,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v.dateFrom.$model) = $event)),
                          class: _normalizeClass({ 'custom-error': _ctx.v.dateFrom.$error, 'is-invalid': _ctx.v.dateFrom.$error }),
                          style: {"flex-basis":"50%"},
                          onEmitDate: _ctx.emitDate,
                          "default-date": [_ctx.dateFrom, _ctx.dateTo]
                        }, null, 8, ["modelValue", "class", "onEmitDate", "default-date"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.v.dateFrom.$error || _ctx.v.source.$error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('customValidators.allMustBeCompleted')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-info btn-sm mt-3 w-100 w-md-25",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addTachoJob && _ctx.addTachoJob(...args)))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-download" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.addTachoJob')), 1)
                ]),
                (_ctx.source !== null && _ctx.source.type === 'transmitter')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "events",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.events) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.events]
                      ]),
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('components.tachographFiles.events')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "technicalData",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.technicalData) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.technicalData]
                      ]),
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('components.tachographFiles.technicalData')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.tachoTasksGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.tachoTasksStore,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            "options-cell-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.resetTachoJob(data.data.id)),
                  style: {"font-size":"16px","margin":"0 10px 0 0"}
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-reply-all" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.resetTachoJob')), 1)
                ], 8, _hoisted_19),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.removeTachoJob(data.data.id)),
                  style: {"font-size":"16px"}
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.deleteTachoJob')), 1)
                ], 8, _hoisted_20)
              ])
            ]),
            "attempt-cell-template": _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.data.attempt) + " / 3 ", 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: true }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 20
              }),
              _createVNode(_component_DxPager, {
                "show-info": true,
                "show-navigation-buttons": true,
                visible: true,
                "info-text": _ctx.$t('components.devexpress.pagerPage')
                + '{0}' + _ctx.$t('components.devexpress.pagerOf')
                + '{1}'
              }, null, 8, ["info-text"]),
              _createVNode(_component_DxSearchPanel, {
                visible: true,
                width: 240,
                placeholder: _ctx.$t('components.tachographFiles.dataGrids.search')
              }, null, 8, ["placeholder"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: "#",
                width: "50",
                "filter-operations": _ctx.allowedOperations,
                "data-field": "id"
              }, null, 8, ["filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": true,
                caption: _ctx.$t('components.tachographFiles.dataGrids.source'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "source"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.imei'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "imei"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.fileType'),
                "data-field": "type"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.status'),
                "data-field": "status"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.attempt'),
                "data-field": "attempt",
                "cell-template": "attempt-cell-template"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachographFiles.dataGrids.options'),
                "cell-template": "options-cell-template",
                "allow-search": false
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"])
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_TASKS]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("a", {
              class: "btn btn-success",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              title: _ctx.$t('components.tachographFiles.massBtn1Additional'),
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.postAllDriversTachoJobs && _ctx.postAllDriversTachoJobs(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-id-card" }),
              _createTextVNode("  " + _toDisplayString(_ctx.$t('components.tachographFiles.massBtn1')), 1)
            ], 8, _hoisted_22),
            _createElementVNode("a", {
              class: "btn btn-success",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              title: _ctx.$t('components.tachographFiles.massBtn2Additional'),
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.postAllVehiclesTachoJobs && _ctx.postAllVehiclesTachoJobs(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-tachograph-digital" }),
              _createTextVNode("  " + _toDisplayString(_ctx.$t('components.tachographFiles.massBtn2')), 1)
            ], 8, _hoisted_23),
            _createElementVNode("a", {
              class: "btn btn-success",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              title: _ctx.$t('components.tachographFiles.massBtn3Additional'),
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.postAllExpiredTachoJobs && _ctx.postAllExpiredTachoJobs(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-hourglass-end" }),
              _createTextVNode("  " + _toDisplayString(_ctx.$t('components.tachographFiles.massBtn3')), 1)
            ], 8, _hoisted_24)
          ]),
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.remindersDriversGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.remindersDriversStore,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            "options-cell-template": _withCtx(({ data }) => [
              (!data.data.has_planned_job && data.data.card !== null && data.data.card_validity >= _ctx.moment().format('YYYY-MM-DD'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.addDriverTachoJob(data.data)),
                    style: {"color":"#1E90FF"}
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-download" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.addTachoJob')) + " ", 1),
                    (data.data.last_download === null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                          _cache[15] || (_cache[15] = _createElementVNode("i", {
                            class: "fa fa-exclamation-triangle",
                            style: {"color":"red !important"}
                          }, null, -1)),
                          _cache[16] || (_cache[16] = _createTextVNode()),
                          _createElementVNode("i", _hoisted_27, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.neverDownloaded')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_25))
                : _createCommentVNode("", true),
              (data.data.has_planned_job)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.taskInProgress')), 1)
                  ]))
                : _createCommentVNode("", true),
              (data.data.card === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                    _cache[18] || (_cache[18] = _createTextVNode()),
                    _createElementVNode("i", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.noDriverCardAssigned')), 1)
                  ]))
                : _createCommentVNode("", true),
              (data.data.card_validity < _ctx.moment().format('YYYY-MM-DD') || data.data.card_validity === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _createElementVNode("i", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.validityDateExpired')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            "driver-cell-template": _withCtx(({ data }) => [
              _createElementVNode("p", null, _toDisplayString(data.data.name), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.card')) + ": " + _toDisplayString(data.data.card ?? '---'), 1)
            ]),
            "last-download-cell-template": _withCtx(({ data }) => [
              (data.data.last_download)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(data.data.last_download), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_32, " --- "))
            ]),
            "next-download-cell-template": _withCtx(({ data }) => [
              (data.data.next_download)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(data.data.next_download), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_34, " --- "))
            ]),
            "remaining-cell-template": _withCtx(({ data }) => [
              (data.data.days_left)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    style: _normalizeStyle({
                  color: data.data.days_left > 7 ? 'green' :
                    data.data.days_left >= 1 ? 'yellow' :
                    'red'
                })
                  }, _toDisplayString(data.data.days_left) + " " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.days')), 5))
                : (_openBlock(), _createElementBlock("p", _hoisted_35, " --- "))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 20
              }),
              _createVNode(_component_DxPager, {
                "show-info": true,
                "show-navigation-buttons": true,
                visible: true,
                "info-text": _ctx.$t('components.devexpress.pagerPage')
                + '{0}' + _ctx.$t('components.devexpress.pagerOf')
                + '{1}'
              }, null, 8, ["info-text"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": true,
                caption: _ctx.$t('components.tachographFiles.dataGrids.driver'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "name",
                width: "200",
                "cell-template": "driver-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.lastDownload'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "last_download",
                "cell-template": "last-download-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.nextDownload'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "next_download",
                "cell-template": "next-download-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.remaining'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "days_left",
                "cell-template": "remaining-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachographFiles.dataGrids.options'),
                "cell-template": "options-cell-template",
                "allow-search": false
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"]),
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.remindersVehiclesGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.remindersVehiclesStore,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            "options-cell-template": _withCtx(({ data }) => [
              (!data.data.has_planned_job)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.addVehicleTachoJob(data.data)),
                    style: {"color":"#1E90FF"}
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-download" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.addTachoJob')) + " ", 1),
                    (data.data.last_download === null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                          _cache[21] || (_cache[21] = _createElementVNode("i", {
                            class: "fa fa-exclamation-triangle",
                            style: {"color":"red !important"}
                          }, null, -1)),
                          _cache[22] || (_cache[22] = _createTextVNode()),
                          _createElementVNode("i", _hoisted_38, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.neverDownloaded')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_36))
                : (data.data.has_planned_job)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.taskInProgress')), 1)
                    ]))
                  : _createCommentVNode("", true)
            ]),
            "vehicle-cell-template": _withCtx(({ data }) => [
              _createElementVNode("p", null, _toDisplayString(data.data.number_plate), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.imei')) + ": " + _toDisplayString(data.data.imei), 1)
            ]),
            "last-download-cell-template": _withCtx(({ data }) => [
              (data.data.last_download)
                ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(data.data.last_download), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_41, " --- "))
            ]),
            "next-download-cell-template": _withCtx(({ data }) => [
              (data.data.next_download)
                ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(data.data.next_download), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_43, " --- "))
            ]),
            "remaining-cell-template": _withCtx(({ data }) => [
              (data.data.days_left)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    style: _normalizeStyle({
                  color: data.data.days_left > 7 ? 'green' :
                    data.data.days_left >= 1 ? 'yellow' :
                    'red'
                })
                  }, _toDisplayString(data.data.days_left) + " " + _toDisplayString(_ctx.$t('components.tachographFiles.dataGrids.days')), 5))
                : (_openBlock(), _createElementBlock("p", _hoisted_44, " --- "))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 20
              }),
              _createVNode(_component_DxPager, {
                "show-info": true,
                "show-navigation-buttons": true,
                visible: true,
                "info-text": _ctx.$t('components.devexpress.pagerPage')
                + '{0}' + _ctx.$t('components.devexpress.pagerOf')
                + '{1}'
              }, null, 8, ["info-text"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": true,
                caption: _ctx.$t('components.tachographFiles.dataGrids.vehicle'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "number_plate",
                width: "200",
                "cell-template": "vehicle-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.lastDownload'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "last_download",
                "cell-template": "last-download-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.nextDownload'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "next_download",
                "cell-template": "next-download-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.tachographFiles.dataGrids.remaining'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "days_left",
                "cell-template": "remaining-cell-template"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachographFiles.dataGrids.options'),
                "cell-template": "options-cell-template",
                "allow-search": false
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"])
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_REMINDERS]
        ])
      ]),
      _: 1
    })
  ]))
}